import { useParams } from '@tanstack/react-router';
import { LotSizing } from '@/features/lot-sizing/lot-sizing';
import { AppLayout } from '@/layouts/app-layout';

export function LotSizingPage() {
  const { id } = useParams({ strict: false });

  return (
    <AppLayout>
      <LotSizing id={`${id}`} />
    </AppLayout>
  );
}
